module.exports = __webpack_public_path__ + "media/images/apple_health/watch/yogasix-9d8368b0c6d49c972edfb818664342f7.svg";